import React, { useEffect } from 'react';
import { HeaderContainer } from './Home.styles';
import { OurOffer } from './Sections/OurOffer'
import { HowItWorks } from './Sections/HowItWorks';
import { Steps } from './Sections/Steps';
import { Campaign } from './Sections/Campaign';
import { WhatNext } from './Sections/WhatNext';
import { Story } from './Sections/Story';
import { MarginWrapper } from '../Dashboard/Dashboard.styles';
import { useAuth } from '../context/auth';

export function Home() {
    const { user } = useAuth();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <MarginWrapper verified={user ? user.verifiedAccount : false}>
                <HeaderContainer>
                    <h1>Create advertising campaigns <br/> in the DoveMed ecosystem</h1>
                    <p>Personalize your ads for better visibility of your business. You decide who can see the content you provide.</p>
                </HeaderContainer>
            </MarginWrapper>
            <OurOffer />
            <HowItWorks />
            <Steps />
            <Campaign />
            <WhatNext />
            {/* <Story /> */}
        </>
    )
}
